import Liquidation from './Liquidation'

export default Liquidation
